import styled, { css } from 'styled-components';

export const Content = styled.div(
  ({ theme }) => css`
    font-size: ${theme.DEPRECATED_ty.medium};
    margin-bottom: ${theme.sz.s4};
  `,
);
